import React from "react";

const LazyImage = ({
  imageBase,
  altText,
  srcs,
  type = "",
  sizes,
  ratio = "",
}) => {
  // Parse the `srcs` into an array
  const srcArr = srcs.split(",");

  // Generate srcset values
  const srcSet = srcArr
    .map((val) => {
      const size = val.trim();
      return `${imageBase.url.replace("{size}", size)} ${size.replace("x", "w")}`;
    })
    .join(", ");

  // Determine fade-in speed and transition type
  let speed = 300;
  let modifier = "";
  let transitionType = "";

  if (type === "spinner") {
    modifier = " lazy--spinner";
    transitionType = " lazy__img--translate-in";
  }

  if (type === "color") {
    modifier = " lazy--color";
    transitionType = " lazy__img--fade-in";
    speed = 1000;
  }

  // Placeholder image (used when type === 'color')
  const placeholder = type === "color" ? imageBase.url.replace("{size}", "1x1") : null;

  return (
    <div
      className={`lazy${modifier} ${ratio}`}
      data-transitionspeed={speed}
    >
      <div className="lazy__loader">
        {/* Intrinsic canvas placeholder */}
        <canvas
          className="lazy__placeholder"
          style={type === "color" ? { backgroundImage: `url('${placeholder}')` } : {}}
          width={imageBase.width}
          height={imageBase.height}
        />
      </div>

      {/* Actual image with lazy-loading attributes */}
      <img
        className={`lazy__img${transitionType} ${ratio}`}
        sizes={sizes}
        alt={altText}
        data-object-fit
        data-src={imageBase.url.replace("{size}", srcArr[0])}
        data-srcset={srcSet}
      />
    </div>
  );
};

export default LazyImage;
